import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import {
  AuditShareLink,
  WebsiteAuditService,
} from '../../website-audit/website-audit.service';

// Landing page for the short website-audit share links (/share/:shortUrl). It
// holds no UI of its own beyond a loader: it resolves the short code to the
// audit share token and hands over to the public audit page
// (/share/website-audit/:token?theme=&uid=).
@Component({
  selector: 'app-decode-token',
  templateUrl: './decode-token.component.html',
  styleUrls: ['./decode-token.component.css'],
})
export class DecodeTokenComponent {
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private websiteAuditService: WebsiteAuditService,
  ) {}

  public hasError: boolean = false;
  public errorMessage: string = '';

  private subs: Subscription = new Subscription();

  ngOnInit(): void {
    const shortUrl = (
      this.route.snapshot.paramMap.get('shortUrl') || ''
    ).trim();

    if (!shortUrl) {
      this.fail();
      return;
    }

    this.subs.add(
      this.websiteAuditService
        .getAuditShareTokenByShortUrl(shortUrl)
        .subscribe({
          next: (res: AuditShareLink) => {
            if (!res?.token) {
              this.fail();
              return;
            }

            this.openSharedAudit(res);
          },
          error: (err: any) => this.fail(err?.error?.message),
        }),
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }

  // The short link is a one-shot redirect, so: keep any extra params it carried
  // (e.g. ?hubspot=, which the share page reads for the booking link), and
  // replace it in history — otherwise Back lands here and resolves it again.
  private openSharedAudit(share: AuditShareLink): void {
    const queryParams: any = {
      ...this.route.snapshot.queryParams,
    };

    if (share.uid) {
      queryParams.uid = share.uid;
    }

    // Only trust a theme the API actually sent; an older record without one
    // keeps whatever the link carried (and the share page defaults to light).
    if (share.theme === 'dark' || share.theme === 'light') {
      queryParams.theme = share.theme;
    }

    this.router.navigate(['/share/website-audit', share.token], {
      queryParams,
      replaceUrl: true,
    });
  }

  private fail(message?: string): void {
    this.hasError = true;
    this.errorMessage = message || '';
  }
}
